import React from 'react'

export default function Container({ children, className = '', id = '' }) {
	return (
		<div id={id} className={`w-container mx-auto ${className}`}>
			{children}
		</div>
	)
}
